<!-- 安全 案例-->
<template>
  <div class="case">
    <h4 class="current">
      您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; 医护人员电子签名解决方案
    </h4>
    <div class="article">
      <h5>医护人员电子签名解决方案</h5>
      <h4 class="smalltit">需求分析</h4>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        在医院信息化建设的逐步健全与完善过程中，往往普遍具有以下几方面的应用安全需求：用户身份真实性鉴别、
        数据完整性保护、业务抗抵赖、权威举证、隐私保护等。
      </p>
      <img src="@/assets/anquan2-1.jpg" />
      <h4 class="smalltit">解决方案</h4>
      <p>
        <span class="boldblack">1.医护技人员身份认证</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为每位医护技人员签发专有的数字证书KEY。在登录院内信息系统时，通过调用签名验证服务器实现对操作人员
        基于数字证书的强身份认证。
      </p>
      <img src="@/assets/anquan2-2.jpg" />

      <p>
        <span class="boldblack">2.医护技人员电子签名</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        医护技人员进行业务操作时，采用可靠的电子签名技术，保证电子数据具有法律效力，实现电子数据的防篡改、 可追溯。
      </p>

      <img src="@/assets/anquan2-3.jpg" />
      <h4 class="smalltit">客户价值</h4>
      <img src="@/assets/anquan2-4.jpg" />
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  }
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url('~@/assets/currentbg.jpg') repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url('~@/assets/ico01.png') no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
